import { bindPopover, bindTrigger } from 'material-ui-popup-state'
import { usePopupState } from 'material-ui-popup-state/hooks'

import EyeOutlinedIcon from '@ant-design/icons/EyeOutlined'

import AvatarGroup from '@mui/material/AvatarGroup'
import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import Fade from '@mui/material/Fade'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Popover from '@mui/material/Popover'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { userRoleToLabel } from '@shared/utils'

import useEntityViewers from '@hooks/useEntityViewers'
import Avatar from '@components/Avatar'

/**
 * Component to display other users currently viewing the same entity
 */
export default function EntityViewers({ entityType, entityId, maxAvatars = 5, compact = false, ...props }) {
  const viewers = useEntityViewers(entityType, entityId)

  const popupState = usePopupState({
    variant: 'popover',
    popupId: `entity-viewers-${entityType}-${entityId}`,
  })

  if (viewers.length === 0) return

  return (
    <>
      <Fade in>
        <Card {...props}>
          <CardActionArea {...bindTrigger(popupState)}>
            <Stack direction="row" spacing={compact ? 1 : 2} sx={{ alignItems: 'center', justifyContent: 'space-between', pl: 1 }}>
              <Stack direction="row" spacing={1} sx={{ alignItems: 'center', color: 'text.secondary' }}>
                <EyeOutlinedIcon style={{ fontSize: compact ? 20 : 24 }} />
                <Typography variant={compact ? 'body2' : 'body1'}>
                  {viewers.length === 1 ? '1 other user viewing' : `${viewers.length} other users viewing`}
                </Typography>
              </Stack>
              <AvatarGroup max={maxAvatars}>
                {viewers.map((viewer) => (
                  <Avatar key={viewer.id} hideStatus user={viewer} variant="circular" size={compact ? 'sm' : 'md'} />
                ))}
              </AvatarGroup>
            </Stack>
          </CardActionArea>
        </Card>
      </Fade>
      <Popover
        {...bindPopover(popupState)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ root: { slotProps: { backdrop: { invisible: false } } } }}
        sx={{ mt: 1 }}
      >
        <Card sx={{ minWidth: 220, maxWidth: 400 }}>
          <List disablePadding>
            {viewers.map((viewer) => (
              <ListItem divider key={viewer.id}>
                <ListItemIcon>
                  <Avatar user={viewer} hover="card" />
                </ListItemIcon>
                <ListItemText primary={viewer.fullName} secondary={userRoleToLabel[viewer.role]} />
              </ListItem>
            ))}
          </List>
        </Card>
      </Popover>
    </>
  )
}
